<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
  >
    <path
      d="M36.0813 33.2679C33.7016 29.1539 30.0344 26.2039 25.7547 24.8054C27.8717 23.5452 29.5164 21.6249 30.4363 19.3395C31.3563 17.054 31.5005 14.5298 30.847 12.1544C30.1935 9.77904 28.7783 7.68385 26.8188 6.19062C24.8592 4.69738 22.4637 3.88867 20.0001 3.88867C17.5364 3.88867 15.1409 4.69738 13.1813 6.19062C11.2218 7.68385 9.80661 9.77904 9.15309 12.1544C8.49957 14.5298 8.64385 17.054 9.56379 19.3395C10.4837 21.6249 12.1284 23.5452 14.2454 24.8054C9.96568 26.2023 6.29849 29.1523 3.91881 33.2679C3.83154 33.4102 3.77366 33.5685 3.74857 33.7336C3.72349 33.8986 3.73171 34.067 3.77275 34.2288C3.81379 34.3906 3.88683 34.5425 3.98754 34.6756C4.08826 34.8087 4.21462 34.9203 4.35916 35.0038C4.5037 35.0873 4.6635 35.141 4.82913 35.1617C4.99476 35.1825 5.16287 35.1698 5.32353 35.1245C5.48419 35.0792 5.63415 35.0022 5.76457 34.8981C5.89499 34.7939 6.00321 34.6646 6.08287 34.5179C9.02662 29.4304 14.2297 26.3929 20.0001 26.3929C25.7704 26.3929 30.9735 29.4304 33.9172 34.5179C33.9969 34.6646 34.1051 34.7939 34.2355 34.8981C34.366 35.0022 34.5159 35.0792 34.6766 35.1245C34.8372 35.1698 35.0054 35.1825 35.171 35.1617C35.3366 35.141 35.4964 35.0873 35.641 35.0038C35.7855 34.9203 35.9119 34.8087 36.0126 34.6756C36.1133 34.5425 36.1863 34.3906 36.2274 34.2288C36.2684 34.067 36.2766 33.8986 36.2515 33.7336C36.2265 33.5685 36.1686 33.4102 36.0813 33.2679ZM11.2501 15.1429C11.2501 13.4123 11.7632 11.7206 12.7247 10.2817C13.6862 8.84275 15.0527 7.72124 16.6516 7.05898C18.2504 6.39671 20.0098 6.22343 21.7071 6.56105C23.4044 6.89867 24.9635 7.73203 26.1872 8.95574C27.4109 10.1794 28.2443 11.7385 28.5819 13.4359C28.9195 15.1332 28.7463 16.8925 28.084 18.4914C27.4217 20.0903 26.3002 21.4568 24.8613 22.4183C23.4224 23.3797 21.7306 23.8929 20.0001 23.8929C17.6802 23.8904 15.456 22.9678 13.8156 21.3274C12.1752 19.687 11.2525 17.4628 11.2501 15.1429Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsUser'
})

defineProps({
  fill: {
    type: String,
    default: '#671cc2'
  }
})
</script>
